var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotoV29LatinRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "roboto-v29-latin-regular_svg__Roboto",
    horizAdvX: 1158
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Roboto",
    unitsPerEm: 2048,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 1900,
    descent: -500,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 507
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 527,
    d: "M347 411H180l-13 1045h194L347 411zM160 93q0 45 27 75t82 31 82-30 28-76-28-74-82-30-81 29-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 655,
    d: "M277 1400l-30-358H136l1 494h140v-136zm270 0l-30-358H406l1 494h140v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1261,
    d: "M765 410H501L421 0H278l80 410H119v137h265l69 354H195v139h285l82 416h143l-82-416h264l82 416h144l-82-416h204V901h-231l-69-354h225V410H909L829 0H685l80 410zM527 547h264l69 354H596l-69-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1150,
    d: "M856 375q0 92-64 155T574 644q-213 65-310 169t-98 266q0 164 95 269t263 125v219h149v-220q168-23 261-141t94-323H844q0 141-67 224t-181 83q-119 0-182-61t-63-172q0-102 66-162t219-110 238-109 126-139 41-185q0-169-101-272T655-17v-191H507v191Q321 0 216 115T110 429h185q0-139 73-214t207-75q131 0 206 63t75 172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1500,
    d: "M105 1176q0 131 83 216t215 85q133 0 215-85t83-222v-71q0-132-83-215t-213-84q-130 0-215 83t-85 223v70zm138-77q0-78 44-128t118-51q71 0 114 49t44 134v73q0 78-43 129t-117 51-117-51-43-133v-73zm571-742q0 131 83 215t215 85 215-84 84-223v-71q0-131-83-215t-214-85-215 83-85 223v72zm138-78q0-79 44-129t118-51q72 0 115 49t43 135v74q0 79-43 129t-117 50q-71 0-115-49t-45-134v-74zM447 110l-105 66 711 1138 105-66L447 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1273,
    d: "M101 391q0 105 58 193t224 205q-97 118-130 190t-33 143q0 166 98 260t266 94q150 0 248-87t98-221q0-88-44-162T730 849l-107-79 324-387q68 130 68 289h167q0-255-123-423L1267 0h-222l-97 115Q874 49 775 15T572-20Q359-20 230 93T101 391zm471-260q147 0 269 112L486 668l-33-24Q286 521 286 391q0-118 76-189t210-71zm-167 997q0-96 118-240l118 83q68 48 93 91t25 106q0 67-50 111t-126 45q-82 0-130-55t-48-141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 357,
    d: "M253 1425l-21-368H103l1 479h149v-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 700,
    d: "M133 591q0 226 60 434t181 378 249 240l38-122q-146-112-239-342T319 664l-1-85q0-386 141-670 85-170 202-266l-38-113q-133 74-254 248-236 340-236 813z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 712,
    d: "M567 581q0-223-58-427T330-224 77-470L38-357Q192-239 285 9t96 552v32q0 210-44 390t-122 324-177 223l39 113q132-73 251-244t179-377 60-441z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 882,
    d: "M330 983l-302 90 46 151 302-112-9 344h153l-10-349 297 110 46-152-307-91 198-271-124-94-186 288-180-281-125 91 201 276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1161,
    d: "M670 781h406V606H670V146H484v460H78v175h406v425h186V781z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 402,
    d: "M134-290L29-218q94 131 98 270v167h181V74q0-101-49-202T134-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 565,
    d: "M525 543H37v151h488V543z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 539,
    d: "M144 97q0 48 28 80t86 32 86-32 30-80q0-46-29-77t-87-31-85 31-29 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 844,
    d: "M177-125H18l608 1581h158L177-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1150,
    d: "M1034 621q0-325-111-483T576-20q-233 0-345 154T115 596v247q0 321 111 477t348 156q235 0 346-150t114-465V621zM849 874q0 235-66 342t-209 108q-142 0-207-107t-67-329V592q0-236 68-348t208-113q137 0 203 106t70 334v303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 1150,
    d: "M729 0H543v1233l-373-137v168l530 199h29V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1150,
    d: "M1075 0H121v133l504 560q112 127 154 206t43 165q0 114-69 187t-184 73q-138 0-214-78t-77-219H93q0 201 129 325t347 124q203 0 321-106t118-284q0-215-274-512L344 151h731V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1150,
    d: "M390 818h139q131 2 206 69t75 181q0 256-255 256-120 0-191-68t-72-182H107q0 173 126 287t322 115q206 0 323-109t117-303q0-95-61-184T766 747q120-38 185-126t66-215q0-196-128-311T556-20 223 91 94 384h186q0-115 75-184t201-69q134 0 205 70t71 201q0 127-78 195t-225 70H390v151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1150,
    d: "M902 489h202V338H902V0H716v338H53v109l652 1009h197V489zm-639 0h453v714l-22-40-431-674z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1150,
    d: "M206 730l74 726h746v-171H437l-44-397q107 63 243 63 199 0 316-131t117-356q0-225-121-354T608-20Q415-20 293 87T154 383h175q17-125 89-188t190-64q129 0 202 88t74 243q0 146-79 234t-212 89q-121 0-190-53l-49-40-148 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1150,
    d: "M847 1457v-157h-34q-216-4-344-128T321 823q115 132 314 132 190 0 303-134t114-346q0-225-122-360T601-20q-209 0-339 160T132 554v71q0 402 171 614t511 218h33zM604 801q-95 0-175-57T318 601v-68q0-180 81-290t202-110q125 0 196 92t72 241q0 150-72 242t-193 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1150,
    d: "M1061 1352L458 0H264l601 1304H77v152h984v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1150,
    d: "M1004 1076q0-109-57-194T791 749q114-49 180-143t67-213q0-189-127-301T575-20Q365-20 239 92T112 393q0 118 64 213t179 144q-97 48-153 133t-56 193q0 184 118 292t311 108q192 0 310-108t119-292zM853 397q0 122-77 199t-203 77-200-76-76-200 73-195 205-71q130 0 204 71t74 195zm-278 927q-109 0-176-67t-68-184q0-111 66-179t178-69 177 68 67 180-69 181-175 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1150,
    d: "M830 640q-58-69-138-111t-177-42q-126 0-219 62T151 723t-51 249q0 146 55 263t158 179 238 62q216 0 340-161t125-441v-54q0-425-168-620T341-1h-36v156h39q229 4 352 119t134 366zm-285 0q93 0 171 57t115 141v74q0 182-79 296t-200 114q-122 0-196-93t-74-247q0-149 71-245t192-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 496,
    d: "M390 97q0 48 28 80t86 32 86-32 30-80q0-46-29-77t-87-31-85 31-29 77zM135 980q0 48 28 80t86 32 86-32 30-80q0-46-29-77t-87-31-85 31-29 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 433,
    d: "M111 980q0 48 28 80t86 32 86-32 30-80q0-46-29-77t-87-31-85 31-29 77zm35-1270L41-218q94 131 98 270v167h181V74q0-101-49-202T146-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1041,
    d: "M264 644l626-253V195L72 574v146l818 378V902L264 644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1124,
    d: "M986 814H152v161h834V814zm0-415H152v160h834V399z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1070,
    d: "M795 650L134 909v190l854-378V575L134 196v192l661 262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 967,
    d: "M357 410q2 119 27 188t102 153l131 135q84 95 84 204 0 105-55 164t-160 60q-102 0-164-54t-62-145H75q2 162 115 261t296 100q189 0 294-101t106-279q0-175-162-345L615 643q-73-81-73-233H357zm-8-317q0 45 27 75t82 31 82-30 28-76-28-74-82-30-81 29-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1839,
    d: "M1738 502q-12-242-120-382T1329-20q-187 0-240 168-54-85-123-126T822-20Q680-20 607 96t-54 321q15 165 75 294t156 204 201 74q81 0 145-21t144-85l-52-554q-19-231 128-231 113 0 183 112t76 292q19 389-144 593t-498 204q-201 0-357-99T364 912 263 478q-12-248 60-430t219-279 357-97q90 0 180 22t151 57l37-115q-62-39-164-64t-208-25q-250 0-430 112T196-17t-78 495q12 275 123 494t301 339 429 120q249 0 427-112t265-323 75-494zM712 417q-14-142 26-218t129-76q60 0 115 51t92 146l1 9 46 503q-56 29-120 29-117 0-193-119t-96-325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1275,
    d: "M169 0v1456h476q237 0 356-98t120-290q0-102-58-180T905 766q118-33 186-125t69-221q0-196-127-308T674 0H169zm192 681V157h317q134 0 211 69t78 192q0 263-286 263H361zm0 154h290q126 0 201 63t76 171q0 120-70 174t-213 55H361V835z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1333,
    d: "M1240 462q-27-231-170-356T688-20q-258 0-413 185T119 660v140q0 203 72 357t206 236 308 83q232 0 372-129t163-359h-193q-25 174-108 252t-234 78q-184 0-288-136T312 795V654q0-237 99-377t277-140q160 0 245 72t114 253h193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1343,
    d: "M169 0v1456h411q190 0 336-84t225-239 81-356v-93q0-206-79-361T916 85 572 0H169zm192 1298V157h202q222 0 345 138t124 393v85q0 248-116 385t-331 140H361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1164,
    d: "M992 673H361V157h733V0H169v1456h915v-158H361V830h631V673z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1132,
    d: "M972 643H361V0H169v1456h902v-158H361V800h611V643z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1395,
    d: "M1244 191q-74-106-206-158T729-20q-178 0-316 83T200 301t-78 357v127q0 329 153 510t432 181q228 0 367-116t170-331h-192q-54 289-344 289-193 0-292-135T315 790V671q0-245 112-389t303-145q108 0 189 24t134 81v327H716v156h528V191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1460,
    d: "M1288 0h-193v673H361V0H169v1456h192V830h734v626h193V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 557,
    d: "M375 0H183v1456h192V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1130,
    d: "M779 1456h193V425q0-209-125-327T512-20Q295-20 174 91T53 402h192q0-125 68-195t199-70q119 0 192 75t75 210v1034z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1284,
    d: "M539 677L361 492V0H169v1456h192V736l647 720h232L667 813 1285 0h-230L539 677z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1102,
    d: "M362 157h690V0H169v1456h193V157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1788,
    d: "M417 1456L893 268l476 1188h249V0h-192v567l18 612L966 0H819L342 1176l19-609V0H169v1456h248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1460,
    d: "M1288 0h-193L362 1122V0H169v1456h193l735-1127v1127h191V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1292,
    d: "M361 570V0H169v1456h537q239 0 374-122t136-323q0-212-132-326T704 570H361zm0 157h345q154 0 236 72t82 210q0 130-82 208t-225 81H361V727z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1408,
    d: "M1281 681q0-211-67-363T1026 79l260-204-131-121L848-2q-72-18-152-18-172 0-305 84T185 305t-76 363v105q0 210 73 371t206 246 306 86q176 0 309-85t206-244 72-373v-93zm-192 94q0 257-102 396t-293 140q-181 0-285-138T301 788V681q0-250 104-394t291-144 288 135 105 389v108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1261,
    d: "M703 589H361V0H168v1456h482q246 0 378-112t133-326q0-136-73-237T883 630l342-618V0h-206L703 589zM361 746h295q143 0 227 74t85 198q0 135-80 207t-233 73H361V746z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1215,
    d: "M598 649q-247 71-359 174t-113 256q0 172 137 284t358 113q150 0 267-58t182-160 65-223H942q0 132-84 207t-237 76q-142 0-221-62t-80-174q0-89 75-150t257-113 284-112 152-144 50-193q0-177-138-283T631-20q-150 0-280 57T151 195 80 422h193q0-132 97-208t261-77q152 0 233 62t81 169-75 165-272 116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1222,
    d: "M1175 1298H707V0H516v1298H49v158h1126v-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1328,
    d: "M1194 1456V466q-1-206-129-337T716-18l-51-2q-239 0-381 129T140 464v992h190V470q0-158 87-245t248-88q163 0 249 87t87 245v987h193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1303,
    d: "M651 255l416 1201h210L737 0H567L28 1456h209L651 255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1817,
    d: "M483 459l28-192 41 173 288 1016h162l281-1016 40-176 31 196 226 996h193L1420 0h-175L945 1061l-23 111-23-111L588 0H413L61 1456h192l230-997z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1284,
    d: "M644 898l349 558h226L759 734 1230 0h-228L644 568 284 0H57l472 734-461 722h225l351-558z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1230,
    d: "M613 725l380 731h218L709 543V0H517v543L15 1456h220l378-731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1226,
    d: "M313 157h833V0H86v144l798 1154H99v158h1015v-141L313 157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 543,
    d: "M523 1512H332V-160h191v-152H146v1976h377v-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 840,
    d: "M40 1456h176L824-125H648L40 1456z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 543,
    d: "M9 1664h378V-312H9v152h193v1672H9v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 856,
    d: "M426 1211L236 729H64l299 727h127l298-727H617l-191 482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 924,
    d: "M920-151H4V0h916v-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 633,
    d: "M474 1242H315L57 1536h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1149,
    d: "M1056 529q0-248-114-398T636-20q-205 0-317 145L310 0H140v1536h185V963q112 139 309 139t309-149 113-408v-16zm-185 21q0 189-73 292T588 945q-183 0-263-170V307q85-170 265-170 133 0 207 103t74 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1072,
    d: "M574 131q99 0 173 60t82 150h175q-5-93-64-177T783 30 574-20q-221 0-351 147T92 531v31q0 158 58 281t166 191 257 68q182 0 302-109t129-283H829q-8 105-79 172t-177 68q-141 0-218-101t-78-294v-35q0-187 77-288t220-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1155,
    d: "M95 550q0 249 118 400t309 152q190 0 301-130v564h185V0H838l-9 116Q718-20 520-20q-188 0-306 154T95 536v14zm185-21q0-184 76-288t210-104q176 0 257 158v497q-83 153-255 153-136 0-212-105t-76-311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1085,
    d: "M589-20q-220 0-358 144T93 511v34q0 161 61 287t172 198 240 72q211 0 328-139t117-398v-77H278q4-160 93-258t228-99q98 0 166 40t119 106l113-88Q861-20 589-20zm-23 970q-112 0-188-81t-94-229h542v14q-8 141-76 218t-184 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 711,
    d: "M231 0v939H60v143h171v111q0 174 93 269t263 95q64 0 127-17l-10-150q-47 9-100 9-90 0-139-52t-49-151v-114h231V939H416V0H231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1149,
    d: "M96 550q0 253 117 402t310 150q198 0 309-140l9 120h169V26q0-210-124-331T551-426q-117 0-229 50T151-239l96 111q119-147 291-147 135 0 210 76t76 214v93Q713-20 521-20q-190 0-307 153T96 550zm186-21q0-183 75-287t210-105q175 0 257 159v494q-85 155-255 155-135 0-211-105t-76-311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1128,
    d: "M325 951q123 151 320 151 343 0 346-387V0H806v716q-1 117-53 173t-164 56q-90 0-158-48T325 771V0H140v1536h185V951z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 497,
    d: "M341 0H156v1082h185V0zM141 1369q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 489,
    d: "M331 1082V-125q0-312-283-312-61 0-113 18v148q32-8 84-8 62 0 94 33t33 117v1211h185zm-204 287q0 44 27 75t81 32q54 0 82-31t28-76-28-75-82-30-81 30-27 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1038,
    d: "M442 501L326 380V0H141v1536h185V607l99 119 337 356h225L566 630 1036 0H819L442 501z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 497,
    d: "M341 0H156v1536h185V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1795,
    d: "M314 1082l5-120q119 140 321 140 227 0 309-174 54 78 140 126t205 48q356 0 362-377V0h-185v714q0 116-53 173t-178 58q-103 0-171-61t-79-166V0H804v709q0 236-231 236-182 0-249-155V0H139v1082h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1130,
    d: "M315 1082l6-136q124 156 324 156 343 0 346-387V0H806v716q-1 117-53 173t-164 56q-90 0-158-48T325 771V0H140v1082h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1149,
    d: "M1054 529q0-247-113-398T635-20q-197 0-310 125v-521H140v1498h169l9-120q113 140 314 140 195 0 308-147t114-409v-17zm-185 21q0 183-78 289T577 945q-168 0-252-149V279q83-148 254-148 133 0 211 105t79 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1164,
    d: "M95 550q0 255 117 403t314 149q192 0 303-129l8 109h170V-416H822v516Q710-20 524-20q-196 0-312 152T95 537v13zm185-21q0-186 78-292t212-106q165 0 252 146v530q-88 143-250 143-134 0-213-106t-79-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 693,
    d: "M663 916q-42 7-91 7-182 0-247-155V0H140v1082h180l3-125q91 145 258 145 54 0 82-14V916z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1056,
    d: "M770 287q0 75-56 116t-197 72-223 72-122 100-40 138q0 133 112 225t288 92q184 0 298-95t115-243H759q0 76-64 131t-163 55q-101 0-158-44t-57-115q0-67 53-101t191-65 225-74 127-103 42-148q0-145-116-232T538-20q-130 0-230 46T152 154 95 333h185q5-93 74-147t184-55q105 0 168 42t64 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 669,
    d: "M391 1344v-262h202V939H391V268q0-65 27-97t92-33q32 0 88 12V0q-73-20-142-20-124 0-187 75t-63 213v671H9v143h197v262h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1129,
    d: "M808 107Q700-20 491-20 318-20 228 80t-92 298v704h185V383q0-246 200-246 212 0 282 158v787h185V0H812l-4 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 992,
    d: "M497 251l268 831h189L566 0H425L33 1082h189l275-831z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1539,
    d: "M1098 255l208 827h185L1176 0h-150L763 820 507 0H357L43 1082h184l213-810 252 810h149l257-827z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1015,
    d: "M503 687l240 395h216L605 547 970 0H756L506 405 256 0H41l365 547-354 535h214l237-395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 969,
    d: "M494 271l252 811h198L509-167Q408-437 188-437l-35 3-69 13v150l50-4q94 0 146 38t87 139l41 110L22 1082h202l270-811z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1015,
    d: "M314 151h633V0H88v136l597 793H97v153h820V951L314 151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 693,
    d: "M632-366q-177 50-266 164t-90 303v199q0 243-212 243v145q212 0 212 242v208q2 183 89 295t267 164l38-115q-209-67-209-349V931q0-227-167-316 167-90 167-319V90q3-275 209-341l-38-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 499,
    d: "M324-270H175v1726h149V-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 693,
    d: "M19-251q203 65 210 331v220q0 231 181 315-181 82-181 315v203q0 282-209 349l38 115q177-50 266-162t90-298V927q0-239 212-239V543q-212 0-212-243V98q0-188-90-301T58-366L19-251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1393,
    d: "M1263 777q0-158-93-266T939 402q-72 0-136 26T655 529t-122 92-79 18q-78 0-120-53t-42-148l-161-2q0 160 92 263t231 103q76 0 146-32t158-112 152-91l29-2q76 0 123 58t48 153l153 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 507
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA1",
    horizAdvX: 499,
    d: "M170 684h168l13-1044H157l13 1044zm188 312q0-45-27-76t-82-31-82 31-28 76 28 75 82 30 81-30 28-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA2",
    horizAdvX: 1120,
    d: "M586 131q100 0 174 60t82 150h175q-6-126-105-226T669-12v-233H484v234Q305 23 205 165T105 527v35q0 212 101 354t278 176v226h185v-223q150-23 246-129t102-256H842q-8 105-79 172t-177 68q-141 0-218-101t-78-294v-35q0-187 77-288t219-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA3",
    horizAdvX: 1190,
    d: "M449 622l8-220q0-154-62-245h733l-1-157H95v157h77q40 9 65 74t27 162v8l-8 221H91v157h160l-9 260q0 199 122 318t323 119q190 0 301-106t111-283H908q0 107-63 169t-175 62q-105 0-170-77t-65-202l9-260h319V622H449z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA4",
    horizAdvX: 1460,
    d: "M1103 112Q944-20 735-20q-207 0-366 130L235-26 105 109l139 141Q140 406 140 608q0 206 112 369l-147 151 130 136 147-150q158 120 353 120 196 0 355-121l149 152 132-137-151-154q110-163 110-366 0-196-102-355l143-144-132-136-136 139zM311 608q0-123 57-229t156-167 211-61 211 61 154 167 57 229q0 122-56 227t-155 166-211 61q-113 0-211-60T369 836t-58-228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA5",
    horizAdvX: 1075,
    d: "M539 793l308 663h213L693 736h261V611H630V446h324V322H630V0H437v322H119v124h318v165H119v125h263L15 1456h216l308-663z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA6",
    horizAdvX: 491,
    d: "M147-270v791h186v-791H147zm186 968H147v758h186V698z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA7",
    horizAdvX: 1256,
    d: "M1145 431q0-189-186-274 69-49 105-117t36-168q0-168-130-267T612-495q-112 0-212 28t-171 85Q90-269 90-64l186 2q0-130 90-205t246-76q136 0 219 58t83 155q0 89-71 141T563 126q-182 48-278 103T143 362 96 551q0 186 182 274-66 49-101 117t-36 168q0 166 133 266t356 100q232 0 362-113t130-318H937q0 125-84 202t-223 78q-142 0-222-57t-81-156q0-69 28-109t95-72 211-73 228-76 141-84 86-113 29-154zM602 691q-90 24-165 51-80-19-117-69t-38-120q0-70 27-110t93-73 209-74 186-58q78 20 120 70t42 120q0 88-69 142T602 691z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA8",
    horizAdvX: 856,
    d: "M101 1371q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA9",
    horizAdvX: 1609,
    d: "M1119 597q0-153-86-233t-245-81q-157 0-251 105t-95 288v110q0 176 95 281t251 106q160 0 246-82t86-231H974q0 99-47 141t-139 43q-94 0-148-69t-54-192V670q0-120 54-189t148-69q92 0 138 42t47 143h146zM206 729q0-172 80-318t217-230 298-83 297 83 217 229 80 319q0 170-79 315t-216 228-299 84q-160 0-298-82t-217-229-80-316zm-115 0q0 202 93 375t259 272 358 100 357-99 258-273 94-375q0-197-90-369T1165 84 801-21Q604-21 439 82T182 358 91 729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAA",
    horizAdvX: 915,
    d: "M618 705q-12 34-18 72-76-86-204-86-119 0-184 62t-65 165q0 111 83 171t256 60h108v52q0 135-124 135-69 0-108-27t-40-78l-161 12q0 103 86 168t223 65q133 0 210-71t77-206V883q0-97 26-178H618zM435 828q43 0 87 20t72 47v142H482q-83-1-127-32t-45-83q0-94 125-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAB",
    horizAdvX: 961,
    d: "M536 804l258-397H653L358 795v19l295 389h141L536 804zm74-256l258-397H727L432 539v19l295 389h141L610 548z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAC",
    horizAdvX: 1134,
    d: "M958 375H772v264H127v161h831V375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAD",
    horizAdvX: 565,
    d: "M525 543H37v151h488V543z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAE",
    horizAdvX: 1610,
    d: "M90 729q0 202 93 375t259 272 358 100 357-99 258-273 94-375q0-197-90-369T1164 84 800-21Q603-21 438 82T181 358 90 729zm115 0q0-172 80-318t217-230 298-83q161 0 299 84t216 230 79 317q0 171-78 315t-217 228-299 84q-160 0-298-82t-217-229-80-316zm448-75V316H512v849h276q153 0 237-65t85-191q0-123-128-188 122-50 123-204v-61q0-86 17-124v-16H977q-14 36-14 128t-3 110q-16 96-131 100H653zm0 128h156q72 2 116 35t44 87q0 73-39 103t-139 31H653V782z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAF",
    horizAdvX: 938,
    d: "M814 1302H142v143h672v-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB0",
    horizAdvX: 765,
    d: "M130 1216q0 104 74 182t181 78q104 0 177-77t74-183q0-106-73-181t-178-75q-105 0-180 75t-75 181zm255-128q54 0 91 35t37 93q0 58-37 95t-91 38q-55 0-92-39t-38-94 37-91 93-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB1",
    horizAdvX: 1094,
    d: "M649 854h364V703H649V289H482v414H97v151h385v413h167V854zM970 0H135v152h835V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB2",
    horizAdvX: 751,
    d: "M683 667H84v108l300 282q109 102 109 171 0 49-32 79t-92 31q-75 0-110-38t-36-95H66q0 114 83 188t216 74 209-63 77-174q0-104-107-211l-84-79-176-145h399V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB3",
    horizAdvX: 751,
    d: "M265 1126h84q74 0 110 30t36 79q0 45-31 74t-102 29q-57 0-94-25t-38-67H73q0 98 81 159t206 62q137 0 215-60t78-165q0-55-35-100t-101-71q149-41 149-184 0-106-85-168t-221-63q-132 0-215 63T62 889h158q0-45 39-75t107-30q70 0 106 30t37 81q0 113-156 115h-88v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB4",
    horizAdvX: 642,
    d: "M316 1536h224l-268-294H123l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB5",
    horizAdvX: 1160,
    d: "M339 1082V449q1-163 52-241t168-78q199 0 261 152v800h186V0H839l-9 115Q737-20 567-20q-147 0-228 73v-469H154v1498h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB6",
    horizAdvX: 1001,
    d: "M646 0v520h-84q-230 0-362 127T67 988q0 213 133 340t363 128h269V0H646z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB7",
    horizAdvX: 534,
    d: "M147 729q0 48 28 80t86 32 86-32 30-80q0-47-29-78t-87-32-85 31-29 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB8",
    horizAdvX: 507,
    d: "M285 0l-12-52q153-27 153-173 0-97-80-153t-223-57l-7 107q79 0 122 26t44 73q0 44-32 65t-130 30L152 0h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB9",
    horizAdvX: 751,
    d: "M495 667H338v601l-216-57v128l355 117h18V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBA",
    horizAdvX: 931,
    d: "M122 1123q0 158 94 255t248 98q155 0 249-96t94-263v-74q0-159-93-256t-248-97-249 97-95 262v74zm163-80q0-100 48-157t133-57q83 0 130 57t48 159v78q0 99-48 156t-132 57q-81 0-129-55t-50-152v-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBB",
    horizAdvX: 960,
    d: "M244 949l295-389v-19L244 152H102l258 398-258 399h142zm349 0l295-389v-19L593 152H451l258 398-258 399h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBC",
    horizAdvX: 1500,
    d: "M458 664H301v601l-216-57v128l355 117h18V664zm-15-546l-104 66 711 1138 104-66L443 118zm875 181h107V169h-107V0h-157v169H786l-6 102 377 518h161V299zm-380 0h223v289l-17-28-206-261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBD",
    horizAdvX: 1589,
    d: "M399 118l-104 66 711 1138 104-66L399 118zm54 546H296v601l-216-57v128l355 117h18V664zM1481 0H882v108l300 282q109 102 109 171 0 49-32 79t-92 31q-75 0-110-38t-36-95H864q0 114 83 188t216 74 209-63 77-174q0-104-107-211l-84-79-176-145h399V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBE",
    horizAdvX: 1593,
    d: "M570 118l-104 66 711 1138 104-66L570 118zm840 181h107V169h-107V0h-157v169H878l-6 102 377 518h161V299zm-380 0h223v289l-17-28-206-261zm-716 827h84q74 0 110 30t36 79q0 45-31 74t-102 29q-57 0-94-25t-38-67H122q0 98 81 159t206 62q137 0 215-60t78-165q0-55-35-100t-101-71q149-41 149-184 0-106-85-168t-221-63q-132 0-215 63t-83 170h158q0-45 39-75t107-30q70 0 106 30t37 81q0 113-156 115h-88v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBF",
    horizAdvX: 969,
    d: "M588 680q-1-106-21-169t-69-123-140-155T255 37l-2-37q0-109 58-166t167-58q100 0 162 56t63 148h185q-2-161-114-263T478-385q-196 0-303 100T68-5q0 173 160 348l109 113q66 78 66 224h185zm8 317q0-45-27-76t-82-31-82 31-28 76q0 44 28 74t82 30 81-30 28-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC0",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm357 1014H619l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC1",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm342 1308h224l-268-294H570l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC2",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm554 1034v-10H822l-150 170-149-170H370v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC3",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm606 1276q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC4",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm-71 1143q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC5",
    horizAdvX: 1336,
    d: "M973 380H363L226 0H28l556 1456h168L1309 0h-197L973 380zM421 538h495l-248 681-247-681zm466 1191q0-87-62-145t-153-59q-92 0-153 59t-62 145 61 147 154 61 153-61 62-147zm-331 0q0-47 33-81t83-34q48 0 82 33t34 82-33 83-83 35q-50 0-83-35t-33-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC6",
    horizAdvX: 1914,
    d: "M1879 0H996l-15 353H417L212 0H-14l880 1456h951v-152h-691l20-471h590V682h-584l22-531h705V0zM518 527h456l-31 733-425-733z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC7",
    horizAdvX: 1333,
    d: "M1240 462q-27-231-170-356T688-20q-258 0-413 185T119 660v140q0 203 72 357t206 236 308 83q232 0 372-129t163-359h-193q-25 174-108 252t-234 78q-184 0-288-136T312 795V654q0-237 99-377t277-140q160 0 245 72t114 253h193zM751-9l-12-52q153-27 153-173 0-97-80-153t-223-57l-7 107q79 0 122 26t44 73q0 44-32 65t-130 30L618-9h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC8",
    horizAdvX: 1164,
    d: "M992 673H361V157h733V0H169v1456h915v-158H361V830h631V673zm-267 891H566l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC9",
    horizAdvX: 1164,
    d: "M992 673H361V157h733V0H169v1456h915v-158H361V830h631V673zM710 1858h224l-268-294H517l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCA",
    horizAdvX: 1164,
    d: "M992 673H361V157h733V0H169v1456h915v-158H361V830h631V673zm-70 911v-10H769l-150 170-149-170H317v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCB",
    horizAdvX: 1164,
    d: "M992 673H361V157h733V0H169v1456h915v-158H361V830h631V673zM297 1693q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCC",
    horizAdvX: 557,
    d: "M375 0H183v1456h192V0zm10 1564H226l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCD",
    horizAdvX: 557,
    d: "M375 0H183v1456h192V0zm-6 1858h224l-268-294H176l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCE",
    horizAdvX: 557,
    d: "M375 0H183v1456h192V0zm207 1584v-10H429l-150 170-149-170H-23v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCF",
    horizAdvX: 557,
    d: "M375 0H183v1456h192V0zM-43 1693q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD0",
    horizAdvX: 1373,
    d: "M199 0v666H7v151h192v639h411q190 0 336-84t225-239 81-356v-93q0-206-79-361T946 85 602 0H199zm444 666H391V157h201q222 0 345 137t125 386v93q0 248-116 385t-331 140H391V817h252V666z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD1",
    horizAdvX: 1460,
    d: "M1288 0h-193L362 1122V0H169v1456h193l735-1127v1127h191V0zm-207 1814q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD2",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108zm-286 779H653l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD3",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108zM797 1848h224l-268-294H604l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD4",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108zm-89 799v-10H856l-150 170-149-170H404v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD5",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108zm-37 1041q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD6",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-172 0-305 84T194 305t-76 363v105q0 210 73 371t206 246 306 86q175 0 308-84t206-245 72-374v-92zm-191 94q0 259-104 397t-291 139q-182 0-286-138T309 788V681q0-251 105-394t291-144q186 0 288 135t105 389v108zm-714 908q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD7",
    horizAdvX: 1092,
    d: "M89 329l330 336-328 335 119 123 329-335 329 335 119-123-328-335 330-336-119-123-331 337-331-337L89 329z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD8",
    horizAdvX: 1408,
    d: "M1289 681q0-214-72-373T1013 64 705-20q-171 0-302 82L306-93H164l144 231Q118 330 118 690v83q0 210 73 371t206 246 306 86q214 0 362-125l103 165h141l-159-255q137-187 139-481v-99zm-980 0q0-244 98-385l564 904q-102 111-268 111-182 0-286-138T309 788V681zm789 94q0 182-56 313L493 207q91-64 212-64 186 0 288 135t105 389v108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD9",
    horizAdvX: 1328,
    d: "M1194 1456V466q-1-206-129-337T716-18l-51-2q-239 0-381 129T140 464v992h190V470q0-158 87-245t248-88q163 0 249 87t87 245v987h193zm-421 96H614l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDA",
    horizAdvX: 1328,
    d: "M1194 1456V466q-1-206-129-337T716-18l-51-2q-239 0-381 129T140 464v992h190V470q0-158 87-245t248-88q163 0 249 87t87 245v987h193zm-436 390h224l-268-294H565l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDB",
    horizAdvX: 1328,
    d: "M1194 1456V466q-1-206-129-337T716-18l-51-2q-239 0-381 129T140 464v992h190V470q0-158 87-245t248-88q163 0 249 87t87 245v987h193zm-224 116v-10H817l-150 170-149-170H365v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDC",
    horizAdvX: 1328,
    d: "M1194 1456V466q-1-206-129-337T716-18l-51-2q-239 0-381 129T140 464v992h190V470q0-158 87-245t248-88q163 0 249 87t87 245v987h193zm-849 225q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDD",
    horizAdvX: 1230,
    d: "M613 725l380 731h218L709 543V0H517v543L15 1456h220l378-731zm95 1121h224l-268-294H515l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDE",
    horizAdvX: 1210,
    d: "M352 1456v-293h279q147 0 257-52t169-150 60-223q0-194-132-309T626 313H352V0H166v1456h186zm0-445V465h277q142 0 222 75t80 196q0 123-80 198t-216 77H352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDF",
    horizAdvX: 1218,
    d: "M324 0H139v1111q0 208 103 325t290 118q180 0 278-89t99-249q0-125-64-226t-64-171q0-51 37-98t132-120 137-140 43-144q0-159-101-248T745-20q-81 0-171 22T445 52l43 155q49-32 116-54t121-22q107 0 163 47t57 129q0 52-37 100T777 528 639 671t-44 150q0 89 69 192t70 188q0 94-52 147t-140 54q-218 0-218-293V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE0",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zm186 1101H528l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE1",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zm171 1395h224l-268-294H479l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE2",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zm383 1121v-10H731l-150 170-149-170H279v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE3",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zm435 1363q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE4",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zM259 1371q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE5",
    horizAdvX: 1114,
    d: "M808 0q-16 32-26 114Q653-20 474-20q-160 0-262 90T109 300q0 169 128 262t362 94h180v85q0 97-58 154t-171 58q-99 0-166-50t-67-121H131q0 81 57 156t156 120 217 44q187 0 293-93t110-258V253q0-149 38-237V0H808zM501 141q87 0 165 45t113 117v222H634q-340 0-340-199 0-87 58-136t149-49zm295 1278q0-87-62-145t-153-59q-92 0-153 59t-62 145 61 147 154 61 153-61 62-147zm-331 0q0-47 33-81t83-34q48 0 82 33t34 82-33 83-83 35q-50 0-83-35t-33-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE6",
    horizAdvX: 1729,
    d: "M1262-20q-261 0-397 180-65-86-178-133T433-20q-167 0-261 86T78 304q0 157 113 244t335 87h223v85q0 107-55 168t-159 62q-105 0-175-55t-70-136l-184 19q0 143 121 233t308 91q115 0 203-41t138-125q63 79 150 122t192 44q210 0 326-128t116-362V497H932q7-176 94-271t236-96q148 0 269 76l47 31 64-136Q1484-20 1262-20zM469 130q72 0 151 37t129 91v237H521q-117-2-187-57t-70-138q0-77 53-123t152-47zm749 820q-115 0-189-85t-92-225h538v31q0 132-67 205t-190 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE7",
    horizAdvX: 1072,
    d: "M574 131q99 0 173 60t82 150h175q-5-93-64-177T783 30 574-20q-221 0-351 147T92 531v31q0 158 58 281t166 191 257 68q182 0 302-109t129-283H829q-8 105-79 172t-177 68q-141 0-218-101t-78-294v-35q0-187 77-288t220-101zM604-9l-12-52q153-27 153-173 0-97-80-153t-223-57l-7 107q79 0 122 26t44 73q0 44-32 65t-130 30L471-9h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE8",
    horizAdvX: 1085,
    d: "M589-20q-220 0-358 144T93 511v34q0 161 61 287t172 198 240 72q211 0 328-139t117-398v-77H278q4-160 93-258t228-99q98 0 166 40t119 106l113-88Q861-20 589-20zm-23 970q-112 0-188-81t-94-229h542v14q-8 141-76 218t-184 78zm105 292H512l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE9",
    horizAdvX: 1085,
    d: "M589-20q-220 0-358 144T93 511v34q0 161 61 287t172 198 240 72q211 0 328-139t117-398v-77H278q4-160 93-258t228-99q98 0 166 40t119 106l113-88Q861-20 589-20zm-23 970q-112 0-188-81t-94-229h542v14q-8 141-76 218t-184 78zm90 586h224l-268-294H463l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEA",
    horizAdvX: 1085,
    d: "M589-20q-220 0-358 144T93 511v34q0 161 61 287t172 198 240 72q211 0 328-139t117-398v-77H278q4-160 93-258t228-99q98 0 166 40t119 106l113-88Q861-20 589-20zm-23 970q-112 0-188-81t-94-229h542v14q-8 141-76 218t-184 78zm302 312v-10H715l-150 170-149-170H263v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEB",
    horizAdvX: 1085,
    d: "M589-20q-220 0-358 144T93 511v34q0 161 61 287t172 198 240 72q211 0 328-139t117-398v-77H278q4-160 93-258t228-99q98 0 166 40t119 106l113-88Q861-20 589-20zm-23 970q-112 0-188-81t-94-229h542v14q-8 141-76 218t-184 78zm-323 421q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEC",
    horizAdvX: 506,
    d: "M341 0H155v1082h186V0zm274 1497H456l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    horizAdvX: 506,
    d: "M341 0H155v1082h186V0zm2 1791h224l-268-294H150l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEE",
    horizAdvX: 506,
    d: "M341 0H155v1082h186V0zm215 1261v-10H403l-150 170-149-170H-49v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEF",
    horizAdvX: 506,
    d: "M341 0H155v1082h186V0zM-69 1370q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF0",
    horizAdvX: 1200,
    d: "M820 1301q249-264 249-673v-93q0-158-58-284T844 52 602-20q-135 0-245 64T187 221t-61 246q0 147 56 263t159 182 233 65q163 0 284-114-48 195-189 336l-218-148-73 99 192 131q-132 91-315 140l57 159q239-54 414-193l189 129 73-100-168-115zm64-666l-2 56q-33 61-102 97t-162 37q-145 0-226-95t-81-263q0-140 83-238t212-98q125 0 201 113t77 297v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF1",
    horizAdvX: 1130,
    d: "M315 1082l6-136q124 156 324 156 343 0 346-387V0H806v716q-1 117-53 173t-164 56q-90 0-158-48T325 771V0H140v1082h175zm612 422q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF2",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312zm404 713H522l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF3",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312zm389 1007h224l-268-294H473l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF4",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312zm601 733v-10H725l-150 170-149-170H273v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF5",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312zm653 975q0-108-61-175t-154-67q-41 0-71 10t-78 41-70 37-50 7q-41 0-70-31t-29-81l-124 7q0 107 60 177t154 70q35 0 63-10t76-39 73-38 57-9q43 0 71 34t29 79l124-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF6",
    horizAdvX: 1168,
    d: "M91 551q0 159 62 286t174 196 255 69q221 0 357-153t137-407v-13q0-158-60-283T843 50 584-20q-220 0-356 153T91 538v13zm186-22q0-180 83-289t224-109q141 0 224 110t83 310q0 178-84 288T582 950q-137 0-221-109t-84-312zm-24 842q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF7",
    horizAdvX: 1169,
    d: "M1069 600H71v184h998V600zm-608 498q0 48 28 80t86 32 86-32 30-80q0-47-29-78t-87-31-85 31-29 78zm0-817q0 48 28 80t86 32 86-32 30-80q0-46-29-77t-87-32-85 31-29 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF8",
    horizAdvX: 1160,
    d: "M91 551q0 159 61 285t174 196 256 70q110 0 204-42l73 148h124l-102-205q195-154 195-474 0-158-62-285T840 49 584-20q-104 0-190 35l-74-149H196L296 69Q91 218 91 551zm185-22q0-194 97-305l343 694q-62 32-134 32-138 0-222-109t-84-312zm614 22q0 182-87 293L463 156q55-25 121-25 139 0 222 109t84 295v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF9",
    horizAdvX: 1129,
    d: "M808 107Q700-20 491-20 318-20 228 80t-92 298v704h185V383q0-246 200-246 212 0 282 158v787h185V0H812l-4 107zM673 1242H514l-258 294h223l194-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFA",
    horizAdvX: 1129,
    d: "M808 107Q700-20 491-20 318-20 228 80t-92 298v704h185V383q0-246 200-246 212 0 282 158v787h185V0H812l-4 107zM658 1536h224l-268-294H465l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFB",
    horizAdvX: 1129,
    d: "M808 107Q700-20 491-20 318-20 228 80t-92 298v704h185V383q0-246 200-246 212 0 282 158v787h185V0H812l-4 107zm62 1155v-10H717l-150 170-149-170H265v12l246 272h112l247-274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFC",
    horizAdvX: 1129,
    d: "M808 107Q700-20 491-20 318-20 228 80t-92 298v704h185V383q0-246 200-246 212 0 282 158v787h185V0H812l-4 107zM245 1371q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFD",
    horizAdvX: 969,
    d: "M494 271l252 811h198L509-167Q408-437 188-437l-35 3-69 13v150l50-4q94 0 146 38t87 139l41 110L22 1082h202l270-811zm105 1265h224l-268-294H406l193 294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFE",
    horizAdvX: 1180,
    d: "M1063 529q0-247-113-398T644-20q-197 0-310 125v-521H149v1952h185V970q113 132 307 132 195 0 308-147t114-409v-17zm-185 21q0 183-78 289T586 945q-168 0-252-149V279q83-148 254-148 133 0 211 105t79 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFF",
    horizAdvX: 969,
    d: "M494 271l252 811h198L509-167Q408-437 188-437l-35 3-69 13v150l50-4q94 0 146 38t87 139l41 110L22 1082h202l270-811zM186 1371q0 45 27 75t82 31 82-30 28-76-28-75-82-30-81 30-28 75zm430-2q0 45 27 76t82 31 82-31 28-76-28-75-82-30-81 30-28 75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2013",
    horizAdvX: 1344,
    d: "M1421 651H419v151h1002V651z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2014",
    horizAdvX: 1599,
    d: "M1737 651H401v151h1336V651z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2018",
    horizAdvX: 409,
    d: "M270 1555l106-72q-93-127-96-274v-136H96v116q0 102 48 202t126 164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2019",
    horizAdvX: 409,
    d: "M153 1046l-105 72q93 130 96 274v144h183v-130q-1-100-49-199t-125-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201A",
    horizAdvX: 407,
    d: "M141-283L36-210q91 127 94 273v118h185V81q0-101-49-202T141-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201C",
    horizAdvX: 724,
    d: "M278 1555l106-72q-93-127-96-274v-136H104v116q0 102 48 202t126 164zm315 0l106-72q-93-127-96-274v-136H419v116q0 102 48 202t126 164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201D",
    horizAdvX: 731,
    d: "M165 1046l-105 72q93 130 96 274v144h183v-130q-1-100-49-199t-125-161zm307 0l-105 72q93 130 96 274v144h183v-130q-1-100-49-199t-125-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201E",
    horizAdvX: 705,
    d: "M141-301L36-229q91 137 94 290v185h185V82q0-108-49-213T141-301zm296 0l-105 72q91 137 94 290v185h186V82q0-107-48-211T437-301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2022",
    horizAdvX: 690,
    d: "M138 772q0 87 55 143t148 56q91 0 148-54t57-148v-37q0-87-55-142t-149-55q-93 0-148 55t-56 144v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2039",
    horizAdvX: 614,
    d: "M286 550l258-397H403L108 541v19l295 389h141L286 550z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u203A",
    horizAdvX: 614,
    d: "M231 949l295-389v-19L231 152H89l258 398L89 949h142z"
  })))));
}
export default SvgRobotoV29LatinRegular;